import React from "react";
import T from "prop-types";
import { Col } from "react-bootstrap";

const headerStyles = {
  marginTop: 0,
  marginBottom: 0
};

const labelStyles = {
  fontSize: 13,
  fontStyle: "italic",
  marginBottom: 10
};

export default function DetailStat({ label, value, offset }) {
  return (
    <Col md={2} sm={2} smOffset={offset} mdOffset={offset}>
      <div className="text-center" style={{ marginBottom: 0 }}>
        <h2 style={headerStyles}>{value}</h2>
        <p className="lead text-muted" style={labelStyles}>
          {label}
        </p>
      </div>
    </Col>
  );
}

DetailStat.propTypes = {
  label: T.string.isRequired,
  value: T.oneOfType([T.string, T.number]),
  offset: T.number
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/DetailStat.jsx